import { useCustomForm } from "@/hooks";
import { displayTime } from "@/libs/dateHelper";
import { mapLocationToString, mapStringToLocation } from "@/hooks/useLocation";
import { useAddEditPostMutation } from "@/services/modules/post";
import { RootState } from "@/store/reducers";
import { FileModel } from "@/types/common";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { addPostSchema, AddPostSchemaModel } from "../types/schema";
import { useLocation, useNavigate } from "react-router-dom";
import { RouteConstant } from "@/routes/routeConstant";
import { PostType } from "../types";
import { PostStatusOption } from "@/utils/listOption";

const useAddPost = ({ type }: { type: PostType }) => {
  const [addEditPost] = useAddEditPostMutation();
  const { firstName, lastName, profileImageUrl, location } = useSelector(
    (state: RootState) => state.login.userDetail
  );
  const { register, formState, setValue, handleSubmit, getValues, reset } =
    useCustomForm<AddPostSchemaModel>({ schema: addPostSchema });
  const currentTime = useMemo(() => displayTime(new Date()), []);
  const files = getValues("files");
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const selectedPost = routeLocation.state?.selectedPost;

  useEffect(() => {
    if (selectedPost)
      reset({
        ...selectedPost,
      });
  }, [selectedPost]);

  useEffect(() => {
    setValue("location", mapStringToLocation(location));
  }, []);

  const handleUploadImg = (name: string, value: FileModel) => {
    setValue("files", [...(files ? files : []), value]);
  };

  const handleRemoveImg = (index: number) => {
    let fileList = files?.slice() ?? [];
    fileList.splice(index, 1);
    setValue("files", fileList);
  };

  async function handleDraft(payload: any) {
    handleSave({ ...payload, isDraft: true });
  }

  async function handleSave({ location, isDraft, ...rest }: any) {
    await addEditPost({
      ...rest,
      type: type.toString(),
      postLocation: mapLocationToString(location),
      postStatus: isDraft ? PostStatusOption.Draft : PostStatusOption.Active,
    }).unwrap();
    reset();
    if (type == PostType.Post) navigate(RouteConstant.Posts);
    else navigate(RouteConstant.Articles);
  }

  return {
    register,
    formState,
    setValue,
    getValues,
    postHeaderDetail: {
      createdByImgUrl: profileImageUrl,
      createdBy: `${firstName} ${lastName}`,
      createdOn: currentTime,
    },
    handleSubmit,
    handleDraft,
    handleSave,
    handleUploadImg,
    handleRemoveImg,
  };
};

export default useAddPost;
